import dayjs from "dayjs";

export const fetchDetailsForUsersIndividually = async (accountIds) => {
  try {
    const promises = accountIds.map(async (accountId) => {
      const res = await window.AP.request(
        `/rest/api/user?accountId=${accountId}`
      );
      const resData = JSON.parse(res.body);
      return resData;
    });

    const response = await Promise.all(promises);
    return response;
  } catch (error) {
    return [];
  }
};

export const getUsersDetails = async ({ records, databaseFieldId }) => {
  try {
    const accountIds = records.map((user) => user.accountId);
    const usersWithDetails = await fetchDetailsForUsersIndividually(accountIds);
    const formattedUsers = usersWithDetails
      .map((user) => {
        const userValues = records.find(
          (r) => r.accountId === user.accountId
        )?.values;

        const dateField = userValues[`recurring_${databaseFieldId}`];
        const formattedDateField = dayjs.unix(dateField).format("MMM D");

        const currentTime = dayjs().hour(0).minute(0).second(0);
        const currentYear = dayjs().get("year");
        const dateUnix = dayjs.unix(dateField);
        const dateUnixCurrentYear = dayjs
          .unix(dateField)
          .set("year", currentYear);

        const yearsLeftFromToday = Math.abs(
          dateUnix.diff(dateUnixCurrentYear, "year")
        );
        let daysLeftFromToday = dateUnixCurrentYear
          .hour(0)
          .minute(0)
          .second(0)
          .diff(currentTime, "day");

        if (daysLeftFromToday < 0) {
          const date = dateUnix
            .set("year", currentYear + 1)
            .hour(0)
            .minute(0)
            .second(0);

          daysLeftFromToday = Math.abs(currentTime.diff(date, "day"));
        }

        return {
          accountId: user.accountId,
          name: user.displayName,
          avatarUrl: `${window.AP._hostOrigin}${user.profilePicture.path}`,
          formattedDateField,
          daysLeft: daysLeftFromToday,
          yearsLeft: yearsLeftFromToday,
          hasBirthday: !!dateField,
        };
      })
      .filter((user) => user.hasBirthday);
    return formattedUsers;
  } catch (error) {
    console.log("error", error);
    console.log("Can not fetch data for users individually.");
    return [];
  }
};
